'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
// 手动百度统计
var handlerStatistics = function handlerStatistics(router) {
    // 阻止自动统计
    window._hmt.push(['_setAutoPageview', false]);
    var base = router.options.base || '/';
    if (router.mode === 'hash') {
        base += '#';
    } else if (base[base.length - 1] === '/') {
        base = base.substr(0, base.length - 1);
    }
    // 使用手动统计
    router.beforeEach(function (to, from, next) {
        // hash 模式手动统计路由
        window._hmt && window._hmt.push(['_trackPageview', base + to.fullPath]);
        next();
    });
};
// 加载百度统计JS
var loadBaiduJs = function loadBaiduJs(id, router) {
    window._hmt = window._hmt || [];
    var hm = document.createElement('script');
    hm.src = 'https://hm.baidu.com/hm.js?' + id;
    hm.onload = function () {
        router && handlerStatistics(router);
    };
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(hm, s);
};

exports.default = {
    init: function init(id, router) {
        if (typeof id === 'string') {
            loadBaiduJs(id, router);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@souche-f2e/statistics/dist/baidu/index.js
// module id = 61O2
// module chunks = 11